import { useAttendeeStatus } from 'amazon-chime-sdk-component-library-react';
import classNames from 'classnames';
import React from 'react';
import { MicrophoneDisabled, Desktop } from 'wix-ui-icons-common';
import { MicrophoneMuted, ScreenShare } from '../../../../icons';
import { useVideoConfig } from '../../../video-config-provider';
import s from './indicators.scss';
export var Indicators = function (_a) {
    var _b;
    var attendeeId = _a.attendeeId;
    var _c = useVideoConfig(), mobile = _c.mobile, dashboard = _c.dashboard;
    var _d = useAttendeeStatus(attendeeId), muted = _d.muted, sharingContent = _d.sharingContent;
    return (React.createElement("div", { className: classNames(s.container, (_b = {}, _b[s.mobile] = mobile, _b)) },
        muted && React.createElement("div", { className: s.icon }, dashboard ? React.createElement(MicrophoneDisabled, null) : React.createElement(MicrophoneMuted, null)),
        sharingContent && React.createElement("div", { className: s.icon }, dashboard ? React.createElement(Desktop, null) : React.createElement(ScreenShare, null))));
};
//# sourceMappingURL=indicators.js.map